// // import '../styles/popup.css';
// import useClassificationStore from "../store/useClassificationStore";

// const VersionPopup = ({ isModalOpen, handleCloseModal, handleSave }) => {
//     const {newVersion,setNewVersion}=useClassificationStore();
//     return (
//         <>
//             {isModalOpen && (
//                 <div
//                     className="modal fade show"
//                     tabIndex="-1"
//                     role="dialog"
//                     style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
//                 >
//                     <div className="modal-dialog modal-lg">
//                         <div className="modal-content">
//                             <div className="modal-header">
//                                 <h5 className="modal-title h4">
//                                     <i className={`fa "fa-info`}></i>{" "}
//                                    Need new version?
//                                    </h5>
//                                 <button type="button" className="close" onClick={handleCloseModal}>
//                                     <span>&times;</span>
//                                 </button>
//                             </div>
//                             <div className="modal-body">
//                                 <form>
//                                     <div className="form-group">
//                                         <label className="col-form-label">Need new version?:</label>
//                                         <select
//                                             className="form-control"
//                                             value={newVersion}
//                                             onChange={(e) => setNewVersion(e.target.value)}
//                                         >
//                                             <option value="">-- Select create version --</option>
//                                             <option value="no">Yes</option>
//                                             <option value="yes">No</option>
//                                         </select>
//                                     </div>
//                                 </form>
//                             </div>
//                             <div className="modal-footer">
//                                 <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
//                                     Cancel
//                                 </button>
//                                 <button type="button" className="btn btn-primary" onClick={handleSave}>
//                                     Done
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default VersionPopup;
